import React from "react";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import MedicationSearchResultRow from "./MedicationSearchResultRow";
import { MedicationSearchResult } from "model/medication-search-result.model";
import { Alert, Form, Page, Spinner } from "@cc/react-components";
import ListGroup from "ui/ListGroup";

export interface Props {
  searchKey: string;
  searchResults: MedicationSearchResult[];
  loading: boolean;
  onSearchMedication(searchKey: string): void;
  onSelectMedication(medication: MedicationSearchResult): void;
}

const MedicationSearch = ({
  searchResults,
  loading,
  onSearchMedication,
  onSelectMedication,
  searchKey,
}: Props) => {
  const [t] = useTranslation();
  return (
    <Page>
      <Page.Body>
        <div className="d-flex flex-column w-100 h-100">
          {renderTextInput(searchKey, onSearchMedication, t)}
          {loading && (
            <div className="flex-grow-1">
              <div className="d-flex align-items-center justify-content-center h-100 pb-4">
                <Spinner animation="brand" size="lg" />
              </div>
            </div>
          )}
          {!loading &&
            (!searchResults || (searchResults.length === 0 && !searchKey)) && (
              <Alert variant="primary">
                {t("medication.medicationMonitoringWarning")}
              </Alert>
            )}
          {!loading && renderSearchResults(searchResults, onSelectMedication)}
        </div>
      </Page.Body>
    </Page>
  );
};

const renderTextInput = (
  searchKey: string,
  onSearchMedication: Function,
  t: TFunction
) => (
  <Form className="mb-3">
    <Form.Input
      placeholder={t("medication.search")}
      value={searchKey}
      onChange={(event: any) => {
        onSearchMedication(event.target.value);
      }}
    />
  </Form>
);

const renderSearchResults = (
  searchResults: MedicationSearchResult[],
  onSelectMedication: Function
) => {
  const items = searchResults.map(
    (searchResult: MedicationSearchResult, index: number) => (
      <ListGroup.Item
        key={index}
        onClick={() => onSelectMedication(searchResult)}
      >
        <MedicationSearchResultRow medicationSearchResult={searchResult} />
      </ListGroup.Item>
    )
  );

  return items.length < 0 ? (
    <div />
  ) : (
    <div className="h-100 d-flex flex-column flex-grow-1 overflow-auto">
      <ListGroup className="pb-3 flex-shrink-0">{items}</ListGroup>
    </div>
  );
};

export default MedicationSearch;
